const m = require('./src')

module.exports = m.default